import React, { useCallback } from 'react';
import css from './CalendarSelectAppt.module.scss';
import { IconHelpCircleSm } from 'src/content/icons';
import classnames from 'classnames';

interface IProps {
    type: string;
    selected: boolean;
    label: string;
    information: string;
    theme: string;
    selectedVehicle?: string;
    infoClick: (type: string, e:any) => void;
}

const CalendarSelectApptLabel = (props: IProps) => {
    const onClick = useCallback((e:any) => {
        props.infoClick(props.type, e);
    }, [props.type, props.infoClick]);

    const btnClassName = classnames(
        css.labelBtn,
        {
            [css.labelBtnCS]: props.theme === 'colorSensitive',
            [css.labelBtnHonda]: props.theme === 'honda',
            [css.labelBtnFord]: props.theme === 'ford',
            [css.labelBtnIN]: props.theme === 'infiniti',

        },
    );

    const btnLitSpanClass = classnames(
        css.btnLitSpan,
        {
            [css.btnLitSpanHonda]: props.theme === 'honda',
            [css.btnLitSpanIN]: props.theme === 'infiniti',
            [css.btnLitSpanMazda]: props.theme === 'mazda',
            [css.btnLitSpanAcura]: props.theme === 'acura',
        },
    );

    const infoData = props.information ?? '';
    let transIcon = css.transIcon;
    if (infoData === '') {
        transIcon += ' ' + css.transIconInvis;
    }
    const infoIcon = (
        <span id='transIcon' className={transIcon} onClick={onClick}>
            <IconHelpCircleSm
                height={30}
                width={30}
            />
        </span>
    );

    return (
        <div id={props.label} className={btnClassName}>
            <span id='btnLit'className={btnLitSpanClass}>{props.label}</span>
            {infoIcon}
        </div>
    );
};

export default CalendarSelectApptLabel;